import { useEffect, useState } from 'react'

import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { FeatureType } from '../types'
import useGetFeatureSet from './useGetFeatureSet'
import { useFeatureEnabled } from '.'

const useFeatureEnabledForOrg = (organizationId: number, featureKey: string, typeHint?: FeatureType) => {
  const currOrg = useCurrentOrg()
  const currOrgEnabled = useFeatureEnabled(featureKey)

  const [getFeatureSet] = useGetFeatureSet()

  const [enabled, setEnabled] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    let cancelled = false
    if (currOrg.id == organizationId) {
      setEnabled(currOrgEnabled)
    } else {
      setEnabled(undefined)
      getFeatureSet(organizationId, typeHint).then(features => {
        if (cancelled) return
        setEnabled(features[featureKey]?.enabled ?? false)
      })
    }

    return () => {
      cancelled = true
    }
  }, [currOrg.id, currOrgEnabled, getFeatureSet, organizationId, featureKey, typeHint])

  return enabled
}

export default useFeatureEnabledForOrg
